export default __webpack_public_path__ + "static/media/instagramIconCircle.c2516d5c.svg";